import { c as _c } from "react/compiler-runtime";
import { WippenSupportSpringsDesignMode, type WippenSupportSpringsDesignTarget, type WippenTensionDesign } from '@/lib/piano/touch-design/design/wippen-support-springs-design';
import type { TouchWeightAnalyzedKeyboard } from '@/lib/piano/touch-design/touch-weight-key-analysis';
import type { TouchDesignSerie } from '@/components/charts/interfaces';
import { useGenerateSerie } from '@/components/charts/hooks/use-generate-serie';
import { useCallback, useMemo } from 'react';
import { TouchDesignSerieVariant } from '@/components/charts/KeyboardChart';
import { generateSupportSpringBalanceWeightCurve } from '@/lib/piano/touch-design/generate-support-spring-balance-weight-curve';
import { useTranslation } from '@/hooks/use-translation';
export const useWippenSupportSpringsTargetSerie = keyboard => {
  const $ = _c(11);
  const {
    t
  } = useTranslation();
  const {
    generateSerie
  } = useGenerateSerie(keyboard);
  let t0;
  if ($[0] !== t) {
    t0 = t("Target");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const name = t0;
  const variant = TouchDesignSerieVariant.Target;
  let t1;
  if ($[2] !== generateSerie || $[3] !== name) {
    t1 = generateSerie(_temp, name, variant);
    $[2] = generateSerie;
    $[3] = name;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const nullTargetSerie = t1;
  let t2;
  if ($[5] !== generateSerie || $[6] !== name || $[7] !== nullTargetSerie) {
    t2 = (mode, target) => {
      if (mode === WippenSupportSpringsDesignMode.AsMeasured) {
        return generateSerie(_temp2, name, variant);
      }
      if (mode === WippenSupportSpringsDesignMode.Constant || mode === WippenSupportSpringsDesignMode.SmoothTransition) {
        const tensionDesign = target as WippenTensionDesign;
        const curve = generateSupportSpringBalanceWeightCurve({
          baseTension: tensionDesign.springBalanceWeight,
          numberOfSprings: tensionDesign.numberOfSprings,
          tensionDropIndex: tensionDesign.tensionDropIndex ?? tensionDesign.numberOfSprings
        });
        return generateSerie(key_0 => key_0.number <= tensionDesign.numberOfSprings ? curve[key_0.number - 1] ?? null : null, name, variant);
      }
      return nullTargetSerie;
    };
    $[5] = generateSerie;
    $[6] = name;
    $[7] = nullTargetSerie;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const generateSupportSpringBalanceWeightTargetSerie = t2;
  let t3;
  if ($[9] !== generateSupportSpringBalanceWeightTargetSerie) {
    t3 = {
      generateWippenSupportSpringTargetSerie: generateSupportSpringBalanceWeightTargetSerie
    };
    $[9] = generateSupportSpringBalanceWeightTargetSerie;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
function _temp() {
  return null;
}
function _temp2(key) {
  return key.payload.supportSpringBalanceWeight;
}